module.exports = __webpack_public_path__ + "img/card_blejska_kartica.8fbdea1e.png";